/**
 * BrandText — "Fill" in default color + "Sign" in green
 */
export function BrandText({ className = "" }: { className?: string }) {
  return (
    <span className={`font-bold tracking-tight ${className}`}>
      Fill<span className="text-accent-green">Sign</span>
    </span>
  );
}
